import { render } from "./form2.vue?vue&type=template&id=1880ee96&scoped=true"
import script from "./form2.vue?vue&type=script&lang=js"
export * from "./form2.vue?vue&type=script&lang=js"

import "./form2.vue?vue&type=style&index=0&id=1880ee96&lang=scss&scoped=true"

import exportComponent from "/root/workspace/adx-frontend_wteR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1880ee96"]])

export default __exports__